import { callApi } from 'modules/core/api/services'
import { ApiResponse } from 'modules/core/api/types'
import { Sport } from '../types'

export const listSports = () => callApi<ApiResponse<Sport[]>>('/v2/sports')
